import { actions } from './action'

const initialState = {
  empPunchReport: [],
  pagination: {
    skip: 0,
    limit: 10,
  },
  totalCount: 0,
}

const onPunchingReport = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_EMP_PUNCH_REPORT:
      return {
        ...state,
        empPunchReport: action.payload.empPunchReport,
        totalCount: action.payload.totalCount ?? state.totalCount,
      }

    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }

    default:
      return state
  }
}
export default onPunchingReport
